



export const getUrl = (rawUrl, storeCode) => {

    return rawUrl;

}


export const getCategoryUrl = (category) => {
    let categoryUrl = category.url;
    if(categoryUrl) {
        return `${categoryUrl}`;
    }

    console.log('CATEGORY URL NOT FOUND', category);
    return '/';
}

export const getCategoryUrlFromCategories = (categoryId, categories) => {
    const category = categories.find(c => c.id===categoryId);
    if(category) {
        return category?.url || '/';
    }
    return '/';
}

export const getEntityUrl = (rawUrl, storeCode) => {

    const country = storeCode.split('_')[1].toLowerCase();
    const lang = storeCode.split('_')[0].toLowerCase();


    rawUrl = rawUrl.indexOf('/')===0 ? rawUrl : '/' + rawUrl;

    return `/${country}/${lang}${rawUrl}`;


}

